<template>
    <PopupRouterView :showLeftIcon="true" label="Vendor Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="vendor"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="vendorInput">


        <b-card header="Vendor" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
						<app-input-textarea id="fieldset-office-address" label-cols-lg="12"  label="Office Address" label-for="input-office-address" size="sm" :model.sync="model.officeAddress"   />
						<app-input-textbox id="fieldset-office-phone-number" label-cols-lg="12"  label="Office Phone Number" label-for="input-office-phone-number" size="sm" :model.sync="model.officePhoneNumber" :thousandSeparator="false"   />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-contact-person" label-cols-lg="12"  label="Contact Person" label-for="input-contact-person" size="sm" :model.sync="model.contactPerson"   />
						<app-input-textbox id="fieldset-contact-person-phone-number" label-cols-lg="12"  label="Contact Person Phone Number" label-for="input-contact-person-phone-number" size="sm" :model.sync="model.contactPersonPhoneNumber" :thousandSeparator="false"  />
						<app-input-textbox id="fieldset-contact-person-email" label-cols-lg="12"  label="Contact Person Email" label-for="input-contact-person-email" size="sm" :model.sync="model.contactPersonEmail"   />
						<app-input-combobox-autocomplete :options="vendorTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor Type" id="fieldset-vendor-type" size="sm" :model.sync="model.vendorTypeId" :isRequired="true" :state="validateState('vendorTypeId')" :errorMessage="getErrorMessage(errorMessage.vendorTypeId, 'vendorTypeId')"   :selected="model.vendorType != null ? model.vendorType.code : ''" @input="getVendorTypes"   :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorType" />
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Vendor from '@/models/Vendor/Vendor';
import VendorList from '@/models/Vendor/VendorList';
import VendorFilter from '@/filters/Vendor/VendorFilter';

import AppInputTextbox from '@/components/AppInputTextboxNumberCustom';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import VendorType from '@/models/VendorType/VendorType';
import VendorTypeFilter from '@/filters/VendorType/VendorTypeFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
			vendorTypeId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
				vendorTypeId: { required : "Vendor Type is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterVendor : null,
			currentVendorPage : 1,
			vendorPageSize: 10,
			sortByVendor: '',
			sortDescVendor: '',
			vendorTypes: [],
			vendorTypes: [],
			isVendorTypeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isVendorTypeComboLoading: false,
		}
	},
	methods : {
		getVendor : async function(id) {
			this.isBusy = true;
			Vendor.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadVendor = true;
			this.filterVendor.id = this.modelId;
			Vendor.downloadDataDetail(this, this.filterVendor).then(result => {
				this.isDownloadVendor = false;
			}).catch(error => { this.isDownloadVendor = false; })
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isVendorComboLoading = true;
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
				this.isVendorComboLoading = false;
			})
			.catch(error => {});
		},
		getVendorTypes : async function(input) {
			let filter = new VendorTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			VendorType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendorTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendorType(item) {
			if(item == undefined || item == null) {
				this.model.vendorTypeId = null;
				this.model.vendorType = null;
			} else {
				this.model.vendorTypeId = item.id;
				this.model.vendorType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.vendorInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			let officeAddress = this.model.officeAddress;
			let officePhoneNumber = this.model.officePhoneNumber;
			let contactPerson = this.model.contactPerson;
			let contactPersonPhoneNumber = this.model.contactPersonPhoneNumber;
			let contactPersonEmail = this.model.contactPersonEmail;

			if (this.model.officeAddress == undefined) {
				this.$set(this.model, 'officeAddress', '');
			}else{
				delete this.model.officeAddress;
				this.$set(this.model, 'officeAddress', officeAddress);
			}

			if (this.model.officePhoneNumber == undefined) {
				this.$set(this.model, 'officePhoneNumber', '');
			}else{
				delete this.model.officePhoneNumber;
				this.$set(this.model, 'officePhoneNumber', officePhoneNumber);
			}

			if (this.model.contactPerson == undefined) {
				this.$set(this.model, 'contactPerson', '');
			}else{
				delete this.model.contactPerson;
				this.$set(this.model, 'contactPerson', contactPerson);
			}

			if (this.model.contactPersonPhoneNumber == undefined) {
				this.$set(this.model, 'contactPersonPhoneNumber', '');
			}else{
				delete this.model.contactPersonPhoneNumber;
				this.$set(this.model, 'contactPersonPhoneNumber', contactPersonPhoneNumber);
			}

			if (this.model.contactPersonEmail == undefined) {
				this.$set(this.model, 'contactPersonEmail', '');
			}else{
				delete this.model.contactPersonEmail;
				this.$set(this.model, 'contactPersonEmail', contactPersonEmail);
			}

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Vendor.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'vendorindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Vendor.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'vendorindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Vendor.updateData(this, model, id)
					.catch((error) => {
						this.getVendor(id);
					});
				}
			});
		},
		onHidden() {
			this.getVendors();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterVendor = new VendorFilter();
		//this.getVendorTypes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getVendor(id);
			} else {
				this.modelId = id;
				this.getVendor(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
}
</script>
